import {InputText} from '@/components/Form/index.mjs'
import FormItemBizProp from '../components/FormItemBizProp.jsx'
import FormChooseDesign from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemUiName, FormItemUiUserCode} from '../UI/FormChooseUi.jsx'
import Model from './ModelUirule.mjs'

export const FormItemRuleTitle = props => (
    <FormItemBizProp
        Model={Model}
        prop="ruleTitle"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export default function FormChooseUirule(props) {
    return (
        <FormChooseDesign {...props}>
            <FormItemUiUserCode />
            <FormItemUiName />
            <FormItemRuleTitle />
        </FormChooseDesign>
    )
}
